<!-- Button -->
<button mat-button [matMenuTriggerFor]="userActions" class="mr-4 h-full">


  <div class="flex h-full justify-start items-center gap-1">
    <span class="relative border border-white rounded-full w-7 h-7">
      <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user.avatar" [src]="user.avatar">
      <mat-icon *ngIf="!showAvatar || !user.avatar" [svgIcon]="'heroicons_outline:user-circle'"
        class="w-7 h-7"></mat-icon>
      <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"></span>
    </span>
    <div class="flex flex-col items-start gap-1 ml-2">

      <span class="text-sm font-sans font-light tracking-wide uppercase text-white">admin wms</span>
      <span class="text-xs text-slate-400 font-sans tracking-wider font-light">{{user.email}}</span>
    </div>
  </div>

</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>{{'Signed in as' | transloco}}</span>
      <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>

  <button mat-menu-item [routerLink]="['/settings']">
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>Settings</span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
